module.exports = __webpack_public_path__ + "static/media/building.95ef695d.png";